import React from "react";
import LmsTable from "../ui/LmsTable";

const LmsFundsFundCapacityCommitment = () => {
  return <LmsTable
    actionButtons={["export"]}
    apiSuffix="funds/fund-capacity-commitment"
    sortable={["Created On"]}
    groupBy={["name"]}
    columnLabelsDictionary={{ loanNumber: "Loan #", applicationNumber: "Application #" }}
    skipClick
  />;
};

export default LmsFundsFundCapacityCommitment;